module.exports = __webpack_public_path__ + "img/VALOR_RESPETO2.e783917a.png";